import React from 'react';
import './style.css'

const Skills = () => {
    return (
        <>
          <div name="skills" className="w-full bg-gradient-to-b from-black via-black to-gray-800">
          <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8 mt-2 ">
          <p className="text-4xl font-bold inline border-b-4 ">
           My Skills
          </p>
          <p className="py-6">Check out some of my working Skills</p>
        </div>
        </div>
          <div className="flex justify-center items-center">
                <div className="partners-intro--thumb aos-init aos-animate bg-[url('https://fieldedge.com/wp-content/themes/fieldedge/assets/dist/images/bg/partners-circle.png')" >
                    <div className="partners-intro--partners">
                        <div className="partners-intro--partners-item -pos-1">
                            <img className="lazy loaded rounded-full"   alt="" src="https://cdn3d.iconscout.com/3d/free/thumb/free-typescript-9294849-7577992.png?f=webp" data-was-processed="true" />
                        </div>
                        <div className="partners-intro--partners-item -pos-2">
                            <img className="lazy loaded rounded-full"   alt="" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSWydNIlbMR4LL7ELylb8TxpGx_nO-stvOjaQ&s" data-was-processed="true" />
                        </div>
                        <div className="partners-intro--partners-item -pos-3">
                            <img className="lazy loaded  rounded-full"   alt="" src="https://ajeetchaulagain.com/static/7cb4af597964b0911fe71cb2f8148d64/87351/express-js.png" data-was-processed="true" />
                        </div>
                        <div className="partners-intro--partners-item -pos-4">
                            <img className="lazy loaded rounded-full"   alt="" src="https://minhphanjavahome.wordpress.com/wp-content/uploads/2019/04/java_logo_640.jpg" data-was-processed="true" />
                        </div>
                        <div className="partners-intro--partners-item -pos-5">
                            <img className="lazy loaded rounded-full"    alt="" src="https://static-00.iconduck.com/assets.00/ant-design-icon-2048x2046-dl3neb73.png" data-was-processed="true" />
                        </div>
                        <div className="partners-intro--partners-item -pos-6">
                            <img className="lazy loaded rounded-full"   alt="" src="https://avatars.githubusercontent.com/u/1515293?s=280&v=4" data-was-processed="true" />
                        </div>
                        <div className="partners-intro--partners-item -pos-7">
                            <img className="lazy loaded rounded-full"   alt="" src="https://cldup.com/xFVFxOioAU.svg" data-was-processed="true" />
                        </div>
                        <div className="partners-intro--partners-item -pos-8">
                            <img className="lazy loaded rounded-full"   alt="" src="https://flatirons.com/static/c8cb21eccc0362e40279fcefdbc7d9b6/d7e39/The-Unofficial-Guide-to-React-Native-1.webp" data-was-processed="true" />
                        </div>
                        
                      
                        


                    </div>
                    <div className="partners-intro--logo">
                        < img className="lazy loaded rounded-full"  alt="" src="https://img.freepik.com/premium-vector/professional-skills-vector-icon-isolated-white-background_775815-968.jpg" data-was-processed="true" />
                    </div>
                </div>
            </div> 
          </div>
           
        </>
    );
};

export default Skills;